module.exports = __webpack_public_path__ + "static/media/8.c778a213.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/8.png
// module id = 2115
// module chunks = 0